var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 30,
    viewBox: "0 0 30 30",
    width: 30,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 2,
    transform: "matrix(-.81915204 -.57357644 .57357644 -.81915204 14.670299 29.418436)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8
  }), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m8 16v7.3894707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.25547369 23.7445263 2.74452631-2.2445263 2.7445263 2.2445263",
    transform: "matrix(-1 0 0 -1 16 45.244526)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMars);
export default __webpack_public_path__ + "static/media/mars.63c9d2d2ed6c78f01dc61211c6447519.svg";
export { ForwardRef as ReactComponent };